// extracted by mini-css-extract-plugin
export var arrow_button = "style-module--arrow_button--ba4f2";
export var blog = "style-module--blog--19cca";
export var blog_container = "style-module--blog_container--6277e";
export var blog_title = "style-module--blog_title--90d05";
export var body_contents = "style-module--body_contents--a5f0d";
export var container = "style-module--container--c1682";
export var top_visual = "style-module--top_visual--7b1d3";
export var top_visual_img = "style-module--top_visual_img--3785e";
export var top_visual_media = "style-module--top_visual_media--40ebf";